import { Controller } from 'stimulus';

export default class extends Controller {
    static targets = ['input', 'form'];

    get maxPerUpload() {
        return this.data.has('maxPerUpload') ? parseInt(this.data.get('maxPerUpload')) : 5;
    }

    get maxTotal() {
        return this.data.has('maxTotal') ? parseInt(this.data.get('maxTotal')) : 12;
    }

    get currentCount() {
        return this.data.has('currentCount') ? parseInt(this.data.get('currentCount')) : 0;
    }

    connect() {
        // Controller connected
    }

    validateAndSubmit(event) {
        const files = this.inputTarget.files;
        const maxPerUpload = this.maxPerUpload;
        const maxTotal = this.maxTotal;
        const currentCount = this.currentCount;

        if (files.length === 0) return;

        // Calculate available slots
        const availableSlots = maxTotal - currentCount;

        // If no slots available, show error and don't upload
        if (availableSlots <= 0) {
            alert('Maximum ' + maxTotal + ' documents allowed. Please delete some documents before uploading new ones.');
            this.inputTarget.value = '';
            return;
        }

        let filesToUpload = files.length;
        let showPerUploadMessage = false;
        let showTotalLimitMessage = false;

        // Check per upload limit (5 files at a time)
        if (files.length > maxPerUpload) {
            filesToUpload = maxPerUpload;
            showPerUploadMessage = true;
        }

        // Check total limit (12 documents overall)
        if (filesToUpload > availableSlots) {
            filesToUpload = availableSlots;
            showTotalLimitMessage = true;
        }

        // Limit files if needed
        if (filesToUpload < files.length) {
            try {
                const dataTransfer = new DataTransfer();
                for (let i = 0; i < filesToUpload; i++) {
                    dataTransfer.items.add(files[i]);
                }
                this.inputTarget.files = dataTransfer.files;
            } catch (e) {
                // Fallback for older browsers/iOS
                console.log('DataTransfer not supported, backend will limit files');
            }
        }

        // Show appropriate message
        if (showTotalLimitMessage) {
            alert('You selected ' + files.length + ' file(s). Only ' + filesToUpload + ' will be uploaded as maximum ' + maxTotal + ' documents are allowed in total.');
        } else if (showPerUploadMessage) {
            alert('You selected ' + files.length + ' file(s). Only first ' + filesToUpload + ' will be uploaded (maximum ' + maxPerUpload + ' per upload).');
        }

        this.formTarget.submit();
    }
}
